import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberRegistrationStepForm from '../../../components/forms/MemberRegistrationStepForm';
import { useCreateMemberRegistrationStep } from '../../../hooks/useMemberRegistrationStepApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { MemberRegistrationStepDTO } from '../../../services/apiClient';

const MemberRegistrationStepCreate: React.FC = () => {
  const createMutation = useCreateMemberRegistrationStep();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Registration Steps', href: '/admin/memberregistrationsteps' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: MemberRegistrationStepDTO) => {
    try {
      await createMutation.mutateAsync(data);
      navigate('/admin/memberregistrationsteps');
    } catch (error) {
      console.error('Error creating MemberRegistrationStep:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/memberregistrationsteps"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.MemberRegistrationStep.Edit'
    >
        <MemberRegistrationStepForm
          initialValues={{} as MemberRegistrationStepDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/memberregistrationsteps')}
        />
    </AdminLayout>
  );
};

export default MemberRegistrationStepCreate;